/* treeUtilities.js */

"use strict";
// const LOCATION_TYPES = require("./views/site_grid_view/siteConstants.js").LOCATION_TYPES;
const _ = require("lodash");
// Sample data for test
// let data = [
//     {
//         "id": 0,
//         "properties": {
//             "path": "path0",
//             "codename": "code-0"
//         }
//     },
//     {
//         "id": 1,
//         "properties": {
//             "path": "path0/path1",
//             "codename": "code-1"
//         }
//     },
//     {
//         "id": 2,
//         "properties": {
//             "path": "path0/path2",
//             "codename": "code-2"
//         }
//     },
//     {
//         "id": 3,
//         "properties": {
//             "path": "path0/path1/path3",
//             "codename": "code-3"
//         }
//     },
//     {
//         "id": 4,
//         "properties": {
//             "path": "path0/path1/path4",
//             "codename": "code-4"
//         }
//     },
//     {
//         "id": 5,
//         "properties": {
//             "path": "path5",
//             "codename": "code-5"
//         }
//     },
//     {
//         "id": 6,
//         "properties": {
//             "path": "path0/path1/path4/path6",
//             "codename": "code-6"
//         }
//     },
//     {
//         "id": 7,
//         "properties": {
//             "path": "path5/path7",
//             "codename": "code-7"
//         }
//     },
//     {
//         "id": 8,
//         "properties": {
//             "path": "path5/path8",
//             "codename": "code-8"
//         }
//     },
//     {
//         "id": 9,
//         "properties": {
//             "path": "path5/path8/path9",
//             "codename": "code-9"
//         }
//     }
// ]

function generateHierarchyObject(data, parentKey, isPath = true, pathSplitter = "/") {
    if (isPath) {
        return generateHierarchyObjectFromPath(data, parentKey, pathSplitter);
    }
    return generateHierarchyObjectFromArray(data, parentKey);
}

function generateHierarchyObjectFromPath(data, parentKey, pathSplitter) {
    let rootName, rootItem;
    let res = data.reduce((acc, item) => {
        const pathVal = item._pristineProperties[parentKey];
        // console.log(item._pristineProperties);
        let pathArray;
        if (pathVal) {
            pathArray = pathVal.split(pathSplitter).filter((path) => !!path);
        } else {
            pathArray = [item._pristineProperties.name];
        }
        if (item._id === item._tenantId) {
            rootName = pathArray[0];
            rootItem = generateNodeAtForPathArray({}, item, pathArray);
            rootItem[rootName].props._pristineProperties.isRoot = true;
            return acc;
        }
        acc = generateNodeAtForPathArray(acc, item, pathArray);
        return acc;
    }, {});
    Object.keys(res).forEach((key) => {
        rootItem[rootName][key] = res[key];
    });
    return rootItem;
}

function generateHierarchyObjectFromArray(data, pathKey) {
    let res = data.reduce((acc, item) => {
        const pathArray = item._pristineProperties[pathKey];
        acc = generateNodeAtForPathArray(acc, item, pathArray);
        return acc;
    }, {});
    // console.log(res);
    return res;
}

function generateNodeAtForPathArray(obj, item, pathArray) {
    let res = obj;
    if (!res[pathArray[0]]) {
        res[pathArray[0]] = {};
    }

    let temp = res;
    if (pathArray.length > 1) {
        for (let i = 0; i < pathArray.length - 1; i++) {
            if (!temp[pathArray[i]]) {
                temp[pathArray[i]] = {};
            }
            temp = temp[pathArray[i]];
        }
    }
    temp[pathArray[pathArray.length - 1]] = Object.assign(
        {},
        temp[pathArray[pathArray.length - 1]]
    );
    let siteIcon = _.snakeCase(item.getLocationTypeLabels()[item._pristineProperties.locationType]);
    if (!siteIcon) {
        siteIcon = "site";
    }
    if (siteIcon === "data_center") {
        siteIcon = "datacenter";
    }
    if (item._id === item._tenantId) {
        siteIcon = "globe";
        item._pristineProperties.isRoot = true;
    }
    temp[pathArray[pathArray.length - 1]].props = Object.assign(
        {},
        _.pick(item, ["_pristineProperties", "_id"]),
        {icon: siteIcon}
    );
    return res;
}

function generateTreeNodes(obj, childrenKey = "items", selectedNodeId = "") {
    let res = {};
    const chProps = Object.keys(obj)
        .filter((item) => item !== "props" && item !== "items")
        .sort((a, b) => a.localeCompare(b, undefined, {numeric: true}));
    if (chProps.length > 0) {
        res[childrenKey] = [];
        // if (spriteClass) {
        //     res.sprite = spriteClass;
        // }
    } else {
        if (obj.props && obj.props._id === selectedNodeId) {
            const _obj = Object.assign({}, obj.props /*, {sprite: spriteClass} */);
            _obj.selected = true;
            _obj.expanded = true;
            return _obj;
        }
        return Object.assign({}, obj.props /*, {sprite: spriteClass} */);
    }
    for (let i = 0; i < chProps.length; i++) {
        res[childrenKey].push(generateTreeNodes(obj[chProps[i]], childrenKey, selectedNodeId));
    }
    if (obj.props) {
        res = Object.assign({}, res, obj.props);
        res.expanded = true;
        if (obj.props && obj.props._id === selectedNodeId) {
            res.selected = true;
        }
    }
    return res;
}

function generateTreeNodesFromRaw(
    data,
    parentKey,
    selectedNodeId,
    childrenKey = "items",
    isPath = true,
    pathSplitter = "/"
) {
    const hObj = generateHierarchyObject(data, parentKey, isPath, pathSplitter);
    return generateTreeNodes(hObj, childrenKey, selectedNodeId);
}

function getAllChildrenPaths(data, pathKey = "path", childrenKey = "items") {
    let childrenList = [];
    childrenList.push(data._pristineProperties.path);
    if (data.items && data.items.length > 0) {
        for (let i = 0; i < data.items.length; i++) {
            childrenList = childrenList.concat(
                getAllChildrenPaths(data.items[i], pathKey, childrenKey)
            );
        }
    }
    return childrenList;
}

function getAllChildrenPathsFromId(
    data,
    id,
    keyToFind = "_id",
    pathKey = "path",
    childrenKey = "items"
) {
    const reqobj = findInObj(data, id, keyToFind, childrenKey);
    if (!reqobj || _.isEmpty(reqobj)) {
        return {pathVals: [], selectedSitePath: null};
    }
    // console.log(reqobj);
    return {
        pathVals: getAllChildrenPaths(reqobj, pathKey, childrenKey),
        selectedSitePath: reqobj._pristineProperties.path,
    };
}

function findInObj(data, id, keyToFind = "_id", childrenKey = "items") {
    let foundObj = null;
    if (data instanceof Array) {
        for (let i = 0; i < data.length; i++) {
            foundObj = findInObj(data[i], id, keyToFind, childrenKey);
            if (foundObj) {
                break;
            }
        }
    } else {
        if (data[keyToFind] && data[keyToFind] === id) {
            return data;
        }
        if (data[childrenKey]) {
            foundObj = findInObj(Array.from(data[childrenKey]), id, keyToFind, childrenKey);
        }
    }
    return foundObj;
}
function generateOptions(data, labelKey = "path", valueKey = "id", prefix = "") {
    let res = [];
    res = data
        .filter((site) => !!site[labelKey])
        .map((site) => {
            return {
                label: prefix + site[labelKey],
                value: site[valueKey],
            };
        });
    return res;
}

function expandItems(arr, data, tv) {
    if (!arr) {
        tv.expand(".k-item");
        return;
    }
    // arr length 0 implies user has toggled expand state and collapsed everything
    if (arr.length === 0) {
        return;
    }
    //expand all by default.
    tv.expand(".k-item");
    // collapse all that are not in arr
    data.forEach((item) => {
        if (item.items && item.items.length > 0) {
            expandItems(arr, item.items, tv);
        }
        if (item._id && arr.indexOf(item._id) < 0) {
            tv.collapse(tv.findByUid(item.uid));
        } else if (!item._id && arr.indexOf("root") < 0) {
            // collapse root  if arr doesnt have root
            tv.collapse(tv.findByUid(item.uid));
        }
    });
}
function expandItemsFromCollapsed(arr, data, tv) {
    if (!arr) {
        // tv.expand(".k-item");
        return;
    }
    expandFromCollapsed(arr, data, tv);
}

function expandFromCollapsed(arr, data, tv) {
    data.forEach((item) => {
        if (item.items && item.items.length > 0 && arr.indexOf(item._id) < 0) {
            expandFromCollapsed(arr, item.items, tv);
        }
        if (item._id && arr.indexOf(item._id) >= 0) {
            tv.collapse(tv.findByUid(item.uid));
        } else if (!item._id && arr.indexOf("root") >= 0) {
            // collapse root  if arr has root
            tv.collapse(tv.findByUid(item.uid));
        }
    });
}
function getExpandedSites(dataItems) {
    let res = {};
    dataItems.forEach((item) => {
        if (item.expanded) {
            res[item._id || "root"] = {
                name: item._pristineProperties.name,
                id: item._id || "root",
                expanded: item.expanded,
            };
        }
        if (item.items && item.items.length > 0) {
            res = Object.assign({}, res, getExpandedSites(item.items));
        }
    });
    return res;
}

function getCollapsedSites(dataItems) {
    let res = {};
    dataItems.forEach((item) => {
        if (!item.expanded && item.items && item.items.length > 0) {
            res[item._id || "root"] = {
                name: item._pristineProperties.name,
                id: item._id || "root",
                expanded: item.expanded,
            };
        }
        if (item.expanded && item.items && item.items.length > 0) {
            res = Object.assign({}, res, getCollapsedSites(item.items));
        }
    });
    return res;
}

module.exports = {
    generateHierarchyObject,
    generateTreeNodes,
    generateTreeNodesFromRaw,
    getAllChildrenPaths,
    generateOptions,
    expandItems,
    getExpandedSites,
    findInObj,
    getAllChildrenPathsFromId,
    getCollapsedSites,
    expandItemsFromCollapsed,
};
